module.exports = __webpack_public_path__ + "img/logosan.c845ea7f.png";